import React, { ChangeEvent } from 'react';

import styles from './Checkbox.module.css';

interface CheckboxProps {
  label: string;
  value: boolean;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FunctionComponent<CheckboxProps> = ({ label, value, handleChange }) => (
  <div className={styles.checkboxContainer}>
    <label data-testid="checkbox-label" htmlFor="checkbox" className={styles.checkboxLabel}>
      <input
        type="checkbox"
        id="checkbox"
        key="checkbox"
        onChange={handleChange}
        checked={value}
        data-testid="checkout-disclaimer-checkbox"
      />
      <span className={styles.checkBoxCheckmark} />
      <span className={styles.checkboxText}>{label}</span>
    </label>
  </div>
);

export default Checkbox;
